/**
 * The WarnixAI mark as the approved mockups draw it (web-10, the sidebar of
 * every web screen): a white shield-check on a brand-blue rounded square,
 * next to the wordmark. Used on the screens that live outside the app
 * shell — sign-in and first-run setup.
 */
import { IconShieldCheck } from "./icons";

const SIZES = {
  28: { box: "w-7 h-7 rounded-lg", icon: "w-4 h-4" },
  40: { box: "w-10 h-10 rounded-[11px]", icon: "w-[22px] h-[22px]" },
  48: { box: "w-12 h-12 rounded-[13px]", icon: "w-[26px] h-[26px]" },
} as const;

export function BrandMark({ size = 28 }: { size?: keyof typeof SIZES }) {
  const s = SIZES[size];
  return (
    <span
      aria-hidden="true"
      className={`${s.box} bg-brand-500 text-white inline-flex items-center justify-center shrink-0 shadow-[inset_0_-1px_0_rgb(0_0_0/0.15)]`}
    >
      <IconShieldCheck className={s.icon} />
    </span>
  );
}

/** Mark + "WarnixAI" (a proper noun: never translated). */
export function BrandLockup({ size = 28 }: { size?: 28 | 40 }) {
  return (
    <span className="inline-flex items-center gap-2.5">
      <BrandMark size={size} />
      <span
        className={`font-bold text-slate-900 tracking-[-0.01em] ${size === 40 ? "text-[22px] leading-7" : "text-base leading-6"}`}
      >
        WarnixAI
      </span>
    </span>
  );
}
